export default {
  withdraw: {
    title: 'Sacar',
    subtitle: 'Rápido, seguro e conveniente',
    secureEncrypted: 'Seguro e Criptografado',
    fiatOrCash: 'Fiduciária/Dinheiro',
    processing: 'Processando...',
    select: 'Selecionar',
    withdrawCurrency: 'Moeda de Saque',
    chooseNetwork: 'Escolher Rede',
    channel: 'Canal',
    withdrawalAddress: 'Endereço de Saque',
    pixKeyType: 'Tipo de Chave PIX',
    accountNumber: 'Número da Conta',
    enterAccountNumber: 'Digite o número da sua conta',
    accountName: 'Nome da Conta',
    enterAccountName: 'Digite o nome do titular da conta',
    pixKey: 'Chave PIX',
    enterPixKey: 'Digite sua chave PIX',
    cpf: 'CPF',
    enterCpf: 'Digite o CPF',
    bankName: 'Nome do Banco',
    enterBankName: 'Digite o nome do banco',
    branch: 'Agência',
    enterBranch: 'Digite a agência (opcional)',
    phone: 'Telefone',
    enterPhone: 'Digite o telefone (opcional)',
    email: 'E-mail',
    enterEmail: 'Digite o e-mail (opcional)',
    available: 'Sacável',
    amountPlaceholder: 'Valor ({unit})',
    min: 'Mín',
    max: 'Máx',
    totalWithdrawalAmount: 'Valor total do saque:',
    fee: 'Taxa:',
    withdrawalAmount: 'Valor do Saque:',
    fundsSafeTitle: 'Seus fundos estão seguros conosco',
    fundsSafeDesc: 'Usamos segurança de ponta para proteger suas transações e informações pessoais.',
    enterWithdrawalAddress: 'Digite o endereço de saque',
    enterAccountNumberRequired: 'Digite o número da sua conta',
    selectChannelRequired: 'Por favor selecione um canal',
    enterAccountNameRequired: 'Digite o nome do titular da conta',
    selectPixKeyTypeRequired: 'Por favor selecione o tipo de chave PIX',
    enterCpfRequired: 'Digite o CPF',
    enterValidAmount: 'Digite um valor válido',
    minWithdrawal: 'Saque mínimo: {amount} {unit}',
    maxWithdrawal: 'Saque máximo: {amount} {unit}',
    insufficientBalance: 'Saldo disponível insuficiente',
    withdrawalRejected: 'Saque rejeitado',
    submittedPendingReview: 'Saque enviado, aguardando análise',
    submittedPayoutInProgress: 'Saque enviado, pagamento em andamento',
    withdrawalFailed: 'Falha no saque',
    withdrawalFailedRetry: 'Falha no saque, tente novamente',
  },
};
